import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import ReplyIcon from "@mui/icons-material/Reply";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import {
  Card,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
} from "@mui/material";
import Rating from "@mui/material/Rating";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import CounterContext from "context/counter";
import { StoreContext } from "context/store";
import parse from "html-react-parser";
import { nanoid } from "nanoid";
import { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import api from "services/api";
import { backendServer } from "services/request";
import socketIOClient from "socket.io-client";

const bgcolor_header = "bg-white";
const bgcolor_body = "bg-white";
const bgcolor_info_body = "bg-[#e1f5fe]";
const bgcolor_owner_body = "bg-gray-200";
const bgcolor_owner_body_plus = "bg-gray-100";
const bgcolor_friend_body = "bg-white";
const bgcolor_friend_body_plus = "bg-transparent";

const NEW_CHAT_MESSAGE_EVENT = "newChatMessage"; // Name of the event
const smartdate = require("smartdate");
smartdate.init();

function capitalize(s) {
  if (s && s.length > 0) return s[0].toUpperCase() + s.slice(1);
  return s;
}

const labelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

let msgProps1 = { elevation: 0, sx: { ...labelProps.sx, mt: -1 } };
const msgProps2 = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: -1,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      left: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const newMsgLabelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: -1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: 0,
      left: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(50%) rotate(-45deg)",
      zIndex: 0,
    },
  },
};

const StarredIcon = () => {
  return (
    <StarOutlinedIcon
      fontSize="small"
      className="text-[#F8AF0B] border-none hover:bg-transparent"
    />
  );
};

const UnStarredIcon = () => {
  return (
    <StarOutlineOutlinedIcon
      fontSize="small"
      color="inherit"
      className="border-none hover:bg-transparent"
    />
  );
};

const FilterIcon = () => {
  return <FilterAltIcon fontSize="small" className="border-none hover:bg-transparent" />;
};

const labels = [
  {
    icon: (
      <Icon fontSize="small" color="primary">
        lightbulb
      </Icon>
    ),
    label: "Design",
    labelId: "design",
  },
  {
    icon: (
      <Icon fontSize="small" color="primary">
        inventory_2
      </Icon>
    ),
    label: "Development",
    labelId: "development",
  },
  {
    icon: (
      <Icon fontSize="small" color="primary">
        shopping_cart
      </Icon>
    ),
    label: "Fabric Sourcing",
    labelId: "sourcing",
  },
  {
    icon: (
      <Icon fontSize="small" color="primary">
        factory
      </Icon>
    ),
    label: "Production",
    labelId: "production",
  },
  { icon: <ClearIcon fontSize="small" color="primary" />, label: "Clear", labelId: "" },
];

const getLabel = (labelId) => {
  if (labelId == "") return null;
  for (const label of labels) {
    if (label.labelId == labelId) return label;
  }
  return null;
};

const ChooseLabel = ({ tag, selectedLabelId, setSelectedLabelId }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  const handleClear = () => {
    setSelectedLabelId("");
    setAnchorEl(null);
    setOpenMenu(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };
  const currentLabel = getLabel(selectedLabelId);
  const newmessagelabel = tag == "newmessagelabel";
  return (
    <>
      <Tooltip
        title={
          currentLabel
            ? currentLabel.label
            : tag == "filterlabel"
            ? "Filter by label"
            : "Add a label"
        }
        placement="top-start"
      >
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={openMenu ? tag : undefined}
          aria-haspopup="true"
          aria-expanded={openMenu ? "true" : undefined}
        >
          {openMenu ? (
            <Icon fontSize="small" color="inherit" className="border-none hover:bg-transparent">
              clear
            </Icon>
          ) : currentLabel ? (
            currentLabel.icon
          ) : tag == "filterlabel" ? (
            <FilterAltIcon fontSize="small" className="border-none hover:bg-transparent" />
          ) : (
            <AddToPhotosIcon fontSize="small" className="border-none hover:bg-transparent" />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id={tag}
        open={openMenu}
        onClose={handleClear}
        onClick={handleClose}
        PaperProps={newmessagelabel ? newMsgLabelProps : labelProps}
        transformOrigin={{
          horizontal: newmessagelabel ? "left" : "right",
          vertical: newmessagelabel ? "bottom" : "top",
        }}
        anchorOrigin={{
          horizontal: newmessagelabel ? "left" : "right",
          vertical: newmessagelabel ? "top" : "bottom",
        }}
      >
        {labels.map((label) => {
          return (
            <MenuItem onClick={(e) => setSelectedLabelId(label.labelId)}>
              {label.icon}
              <SuiTypography>&nbsp;&nbsp;{label.label}</SuiTypography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export const RenderChatMenu = ({
  userid,
  chatdata,
  parentReload,
  setRelStatus = null,
  socketRef = null,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [blockDialogVisible, setBlockDialogVisible] = useState(false);
  const regardingid = chatdata.regardingid;
  const isProjectRelated = regardingid ?? false;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    event.stopPropagation();
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    setOpenMenu(false);
    event.stopPropagation();
  };
  const markAsUnread = () => {
    try {
      api.chatroom.markAsUnread(chatdata.id).then(({ data }) => {
        if (parentReload) parentReload(false);
        return data;
      });
    } catch (err) {
      toast.error(`markAsUnread failed!`);
      console.log(err);
    }
  };
  const relSetStatus = (status) => {
    try {
      api.chatroom.relSetStatus(chatdata.id, status).then(({ data }) => {
        if (socketRef)
          socketRef.current?.emit(NEW_CHAT_MESSAGE_EVENT, {
            body: "",
            senderId: userid,
            contacts: [],
          });
        if (setRelStatus) setRelStatus(data.result);
        if (parentReload) parentReload(status == 1);
        return data;
      });
    } catch (err) {
      toast.error(`relSetStatus failed!`);
      console.log(err);
    }
  };
  const hideChat = () => {
    try {
      api.chatroom.hideChat(chatdata.id).then(({ data }) => {
        if (parentReload) parentReload(true);
        return data;
      });
    } catch (err) {
      toast.error(`hideChat failed!`);
      console.log(err);
    }
  };
  return (
    <>
      <Tooltip title="Options" placement="top-start">
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={openMenu ? "chat-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openMenu ? "true" : undefined}
        >
          <MoreVertIcon
            fontSize="small"
            color="inherit"
            className="border-none hover:bg-transparent"
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="chat-menu"
        open={openMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={labelProps}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {1 == 2 && chatdata.isgroup && (
          <MenuItem onClick={(e) => markAsUnread()}>
            <EditIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Edit Group Chat</SuiTypography>
          </MenuItem>
        )}
        {isProjectRelated && (
          <Link
            to={
              chatdata.regardingownerid == userid
                ? `/produce/all-projects?id=${regardingid}`
                : `/job/requests?id=${regardingid}`
            }
            target="_blank"
            style={{ color: "inherit" }}
          >
            <MenuItem>
              <ChromeReaderModeIcon className="align-middle" fontSize="small" />
              <SuiTypography>&nbsp;&nbsp;View Project</SuiTypography>
            </MenuItem>
          </Link>
        )}
        {isProjectRelated && chatdata.contactaccounttype == "ma" && (
          <Link
            to={`/wall/portfolio/${chatdata.contactid}`}
            target="_blank"
            style={{ color: "inherit" }}
          >
            <MenuItem>
              <AccountCircleIcon className="align-middle" fontSize="small" />
              <SuiTypography>&nbsp;&nbsp;View Manufacturer Profile</SuiTypography>
            </MenuItem>
          </Link>
        )}
        {chatdata.status == 0 && (
          <MenuItem onClick={(e) => markAsUnread()}>
            <MarkAsUnreadIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Mark as unread</SuiTypography>
          </MenuItem>
        )}
        {!isProjectRelated && chatdata.status == 0 && (
          <MenuItem onClick={(e) => setBlockDialogVisible(true)}>
            <Icon className="align-middle" fontSize="small">
              block
            </Icon>
            <SuiTypography>&nbsp;&nbsp;Block Chat</SuiTypography>
          </MenuItem>
        )}
        {!isProjectRelated && chatdata.status == 0 && (
          <MenuItem onClick={(e) => hideChat()}>
            <Icon className="align-middle" fontSize="small">
              hide_source
            </Icon>
            <SuiTypography>&nbsp;&nbsp;Hide Chat</SuiTypography>
          </MenuItem>
        )}
        {!isProjectRelated && chatdata.status == 1 && (
          <MenuItem onClick={(e) => relSetStatus(0)}>
            <Icon className="align-middle" fontSize="small">
              lock_open
            </Icon>
            <SuiTypography>&nbsp;&nbsp;Unblock Chat</SuiTypography>
          </MenuItem>
        )}
      </Menu>
      <Prompt
        heading="Block Chat"
        text={`Are you sure you want to block this conversation?`}
        visible={blockDialogVisible}
        okText="Block"
        okColor="dark"
        handleOk={() => {
          setBlockDialogVisible(false);
          relSetStatus(1);
        }}
        handleClose={() => setBlockDialogVisible(false)}
      />
    </>
  );
};

export const getChatTooltip = (chatdata) => {
  var tooltip = "";
  if (chatdata?.contacts) {
    chatdata?.contacts.sort((a, b) => (a.name < b.name ? 1 : -1));
    for (const contact of chatdata?.contacts) {
      if (contact.type == 1) {
        continue;
      }
      tooltip = tooltip + contact.name + "\n";
    }
  }
  return tooltip;
};

const ChatRoom = ({
  id,
  regardingid,
  parentReload,
  setChatRoomId,
  backaction = null,
  cardClassName = "",
}) => {
  const [chatdata, setChatData] = useState({});
  const [relstatus, setRelStatus] = useState(0);
  const [messageList, setmessageList] = useState([]);
  const [message, setMessage] = useState("");
  const [inSearchMode, setInSearchMode] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [searchStr, setSearchStr] = useState("");
  const [inStarMode, setInStarMode] = useState(false);
  const [newMsgStar, setNewMsgStar] = useState(false);
  const [labelFilter, setLabelFilter] = useState("");
  const [newMsgLabel, setNewMsgLabel] = useState("");
  const [originMsg, setOriginMsg] = useState(null);
  const [focusMsg, setFocusMsg] = useState(null);
  const [reviewdata, setReviewData] = useState({ rating: 0, value: "" });
  const isProjectRelated = regardingid ?? false;

  const account = useContext(AccountContext);
  const msgcounter = useContext(CounterContext);
  const { store } = useContext(StoreContext);
  let userid = account.id;
  const focusRef = useRef(null);
  const socketRef = useRef(null);
  const reloadRef = useRef();

  var avatorsize = backaction === null ? "sm" : "xs";

  const reload = () => {
    setFocusMsg(null);
    if (id) {
      try {
        api.chatroom
          .getChatRoom(id, { star: inStarMode, label: labelFilter, search: searchStr })
          .then(({ data }) => {
            setChatData(data.chat);
            setmessageList(data.chat.content);
            setRelStatus(data.chat.status);
            if (parentReload) parentReload(false);
            else msgcounter.getNewMessageCount();
            return data;
          });
      } catch (err) {
        toast.error(`getChatRoom failed!`);
        console.log(err);
      }
    }
  };
  reloadRef.current = reload;

  const refreshReview = () => {
    try {
      api.notes
        .get({ resource_id: chatdata.contactid, project_id: chatdata.regardingid })
        .then(({ data }) => {
          if (data.note.id) setReviewData(data.note);
          return data;
        });
    } catch (err) {
      toast.error(`get review failed!`);
      console.log(err);
    }
  };

  useEffect(() => {
    if (chatdata.regardingstatus == "completed") {
      refreshReview();
    }
  }, [chatdata]);

  useEffect(() => {
    reload();
  }, [searchStr, inStarMode, labelFilter]);

  useEffect(() => {}, [searchTxt]);

  useEffect(() => {
    setMessage("");
    setInSearchMode(false);
    setSearchTxt("");
    setSearchStr("");
    setInStarMode(false);
    setNewMsgStar(false);
    setLabelFilter("");
    setNewMsgLabel("");
    setOriginMsg(null);
    reload();
    if (id) {
      let roomId = id;
      socketRef.current = socketIOClient(backendServer, {
        query: { roomId },
      });
      socketRef.current.on(NEW_CHAT_MESSAGE_EVENT, (message) => {
        if (userid != message.senderId) {
          //console.log('message', message)
          reloadRef.current();
        }
      });
      return () => {
        socketRef.current?.disconnect();
      };
    }
  }, [id, relstatus]);

  useEffect(() => {
    focusRef.current?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [messageList]);

  useEffect(() => {
    if (focusMsg) focusRef.current?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [focusMsg]);

  const getContact = (contactid) => {
    for (const contact of chatdata.contacts) {
      if (contact.id == contactid) return contact;
    }
    return chatdata.contacts[0];
  };

  const replyAction = (messagebody) => {
    if (originMsg) {
      messagebody.replyid = originMsg.id;
      messagebody.replytext = originMsg.text;
      messagebody.replyuserid = originMsg.user_id;
      if (messagebody.label == "" && originMsg.label != "") messagebody.label = originMsg.label;
      setOriginMsg(null);
    }
  };

  const sendmessage = (messagebody, reloadpage = false) => {
    try {
      api.chatroom.sendmessage(id, messagebody).then(({ data }) => {
        reload();
        if (socketRef.current)
          socketRef.current?.emit(NEW_CHAT_MESSAGE_EVENT, {
            body: messagebody,
            senderId: userid,
            projectid: chatdata.regardingid,
            contacts: chatdata.contacts.filter((c) => c.type == 0),
          });
        if (reloadpage) window.location.reload(false);
        return data;
      });
    } catch (err) {
      toast.error(`sendmessage failed!`);
      console.log(err);
    }
  };

  const sendMessageData = () => {
    if (message) {
      let msg = message.trim();
      setMessage("");
      if (msg) {
        let messagebody = { text: msg, type: 0, star: newMsgStar, label: newMsgLabel };
        replyAction(messagebody);
        sendmessage(messagebody);
      }
    }
  };

  const handleUpload = async ({ file }) => {
    var file2 = new File([file], nanoid() + "_" + file.name, { type: file.type });
    const url = await api.uploads.create([file2]).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      let messagebody = {
        text: file.name,
        type: 1,
        url: url[0],
        size: file.size,
        star: newMsgStar,
        label: newMsgLabel,
      };
      replyAction(messagebody);
      sendmessage(messagebody);
    }
  };

  const updateProjectStatus = async (status) => {
    var payload = { id: chatdata.regardingid, status: status };
    if (status == "active") {
      payload.provider_id = userid;
    }
    try {
      const { data } = await api.project.updateStatus(payload);
    } catch (err) {
      toast.error(err.response.data.message);
      console.log("err", err);
      return false;
    }
    return true;
  };

  const MessageItem = ({ messageData }) => {
    function isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    }

    function getReadableFileSizeString(fileSizeInBytes) {
      var i = -1;
      var byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);
      return Math.max(fileSizeInBytes, 0.1).toFixed(2) + " " + byteUnits[i];
    }

    const [isHovered, setIsHovered] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isStarred, setIsStarred] = useState(messageData.star);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [reviewDialogVisiable, setReviewDialogVisiable] = useState(false);
    const [recallDialogVisiable, setRecallDialogVisiable] = useState(false);
    const [recallId, setRecallId] = useState(false);
    const [reviewMessage, setReviewMessage] = useState("");
    const [reviewRating, setReviewRating] = useState(0);

    const [response, setResponse] = useState(null);

    const isInfo = messageData.type == 2;
    const contact = getContact(messageData.user_id);
    const label = getLabel(messageData.label ?? "");

    useEffect(() => {
      setReviewMessage(reviewdata.value);
      setReviewRating(reviewdata.rating);
    }, []);

    useEffect(() => {
      setReviewMessage(reviewdata.value);
      setReviewRating(reviewdata.rating);
    }, [reviewdata]);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setOpenMenu(true);
    };
    const handleClose = () => {
      setAnchorEl(null);
      setOpenMenu(false);
    };
    const replyAction = () => {
      setOriginMsg(messageData);
      handleClose();
    };
    const setMsgStar = (starred) => {
      let messagebody = { id: messageData.id, star: starred };
      try {
        api.chatroom.setmsgstar(id, messagebody).then(({ data }) => {
          setIsStarred(starred);
          return data;
        });
      } catch (err) {
        toast.error(`setmsgstar failed!`);
        console.log(err);
      }
      handleClose();
    };
    const setRequestResponse = (answer, messageData) => {
      var desc = "";
      var text = "";
      var de_name = store.name;
      var ma_name = chatdata.name;
      var proj_name = chatdata.regardingname;
      if (answer == "Withdraw") {
        text = messageData.tag + " Withdrew";
        desc = text + ` by <b><i>${de_name}</i></b>`;
      }
      if (answer == "Decline") {
        de_name = chatdata.name;
        ma_name = store.name;
        text = messageData.tag + " Declined";
        if (messageData.tag == "Start Project")
          desc = `Unfortunately, <b><i>${ma_name}</i></b> will not be working with <b><i>${de_name}</i></b> at this time.\nWe encourage you to network with other prospects or feel free to resubmit your project request at any time.`;
        else if (messageData.tag == "Cancel Project")
          desc = `Unfortunately, <b><i>${ma_name}</i></b> did not agree to cancel project <b><i>${proj_name}</i></b>.\nPlease reach out to <b><i>${ma_name}</i></b> to resolve any issues`;
        else if (messageData.tag == "Complete Project")
          desc = `Unfortunately, <b><i>${ma_name}</i></b> did not agree to complete project <b><i>${proj_name}</i></b>.\nPlease reach out to <b><i>${ma_name}</i></b> to resolve any issues`;
      }
      if (answer == "Accept") {
        de_name = chatdata.name;
        ma_name = store.name;
        text = messageData.tag + " Accepted";
        if (messageData.tag == "Start Project")
          desc = `Congratulations! <b><i>${ma_name}</i></b> has accepted your project request. Feel free to send them a message here at any time.`;
        else if (messageData.tag == "Cancel Project")
          desc = `${ma_name}</i></b> has already confirmed that project <b><i>${proj_name}</i></b> has been canceled.\nPlease revisit the Project Dashboard and connect with our community of independent designers.`;
        else if (messageData.tag == "Complete Project")
          desc = `Congratulations! <b><i>${ma_name}</i></b> have already confirmed that project <b><i>${proj_name}</i></b> has been completed.\nPlease revisit the Project Dashboard and connect with our community of independent designers.`;
      }
      setResponse({
        text: text,
        tag: messageData.tag,
        type: 4,
        answer: answer,
        desc: desc,
      });
      setDialogVisible(true);
    };
    // console.log("messageData", messageData, "contact", contact);
    return (
      <div
        key={messageData.id}
        className={`relative mb-3 p-1 flex w-full items-center ${
          isInfo
            ? "justify-center text-center"
            : contact.type == 1
            ? "justify-end"
            : "justify-start"
        } `}
      >
        {!isInfo && !contact.type == 1 && <ContactAvatar contact={contact} size={avatorsize} />}
        <Card
          className={`min-w-[25%] max-w-[75%] mx-1 ${
            isInfo
              ? bgcolor_info_body
              : contact.type == 1
              ? bgcolor_owner_body
              : bgcolor_friend_body
          }`}
          onMouseEnter={() => {
            setFocusMsg("");
            setIsHovered(true);
          }}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isHovered && !isInfo && !messageData.recalled && (
            <div>
              <IconButton
                className="absolute -mt-3 -mr-1.5 top-0 right-0 z-10 bg-transparent hover:bg-transparent border-none outline-none"
                size="medium"
                onClick={handleClick}
                aria-controls={isHovered ? "message-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isHovered ? "true" : undefined}
              >
                <KeyboardArrowDownOutlinedIcon
                  fontSize="medium"
                  color="inherit"
                  className="border-none outline-none hover:bg-transparent bg-transparent"
                />
              </IconButton>
              {recallDialogVisiable && (
                <Prompt
                  heading={"Recall Message"}
                  option={{ maxWidth: "md", fullWidth: true }}
                  text="Are you sure you want to recall this message?"
                  visible={recallDialogVisiable}
                  okText="Recall"
                  okColor="dark"
                  handleOk={() => {
                    let messagebody = {
                      text: "This message was recalled.",
                      type: -1,
                      recallId: recallId,
                    };
                    sendmessage(messagebody);
                    setRecallDialogVisiable(false);
                  }}
                  handleClose={() => setRecallDialogVisiable(false)}
                />
              )}
              <Menu
                anchorEl={anchorEl}
                id="message-menu"
                open={openMenu}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={contact.type == 1 ? msgProps1 : msgProps2}
                transformOrigin={{
                  horizontal: contact.type == 1 ? "right" : "left",
                  vertical: "top",
                }}
                anchorOrigin={{
                  horizontal: contact.type == 1 ? "right" : "left",
                  vertical: "bottom",
                }}
              >
                <MenuItem onClick={replyAction}>
                  <ReplyIcon />
                  <SuiTypography>&nbsp;&nbsp;Reply</SuiTypography>
                </MenuItem>
                {contact.type == 1 &&
                  messageData.type == 0 &&
                  Date.now() - new Date(messageData.ts) < 300000 && (
                    <MenuItem
                      onClick={() => {
                        setRecallId(messageData.id);
                        setRecallDialogVisiable(true);
                      }}
                    >
                      <DeleteIcon />
                      <SuiTypography>&nbsp;&nbsp;Recall</SuiTypography>
                    </MenuItem>
                  )}
                {!messageData.desc &&
                  (isStarred ? (
                    <MenuItem onClick={() => setMsgStar(false)}>
                      <UnStarredIcon />
                      <SuiTypography>&nbsp;&nbsp;Unstar Message</SuiTypography>
                    </MenuItem>
                  ) : (
                    <MenuItem onClick={() => setMsgStar(true)}>
                      <StarredIcon />
                      <SuiTypography>&nbsp;&nbsp;Star Message</SuiTypography>
                    </MenuItem>
                  ))}
              </Menu>
            </div>
          )}
          {messageData.replyid && (
            <Card
              sx={{ cursor: "pointer" }}
              className={`rounded-lg h-14 mt-2 mb-2 p-2 ${
                contact.type == 1 ? bgcolor_owner_body_plus : bgcolor_friend_body_plus
              }`}
            >
              <SuiTypography
                variant="body1"
                className={`line-clamp-2`}
                onClick={() => {
                  setFocusMsg(messageData.replyid);
                }}
              >
                {(messageData.replyuserid == userid
                  ? "You"
                  : getContact(messageData.replyuserid).name) +
                  ": " +
                  messageData.replytext.replaceAll("\n", ".").replaceAll(/\.\.+/g, ".")}
              </SuiTypography>
            </Card>
          )}
          <p className="mb-1 pt-2 pb-0 px-2">
            {messageData.type == 1 && (
              <Card
                className={`w-full rounded-lg p-2 ${
                  contact.type == 1 ? bgcolor_owner_body_plus : bgcolor_friend_body_plus
                }`}
              >
                {isImage(messageData.url) && (
                  <img
                    alt={messageData.text}
                    className="max-w-[250px] h-auto rounded mb-1"
                    src={messageData.url}
                    onClick={() => window.open(messageData.url, "_blank")}
                  />
                )}
                <div className="flex items-center justify-start">
                  <FileOpenIcon fontSize="large" className="mr-2" />
                  <a
                    href={messageData.url}
                    className={`text-black text-lg ${
                      contact.type == 1 ? bgcolor_owner_body_plus : bgcolor_friend_body_plus
                    }`}
                    target="_blank"
                  >
                    <SuiTypography>{messageData.text}</SuiTypography>
                  </a>
                </div>
                <SuiTypography className="leading-5 opacity-60">
                  {getReadableFileSizeString(messageData.size)}
                </SuiTypography>
              </Card>
            )}
            {(messageData.type == 3 || messageData.type == 4) && (
              <Card
                className={`w-full rounded-lg p-2 ${
                  contact.type == 1 ? bgcolor_owner_body_plus : bgcolor_friend_body_plus
                }`}
              >
                <SuiTypography variant="h6" sx={{ ml: 2.5 }}>
                  {messageData.text}
                </SuiTypography>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <SuiTypography variant="body1" className="whitespace-pre-line">
                      {parse(messageData.desc)}
                    </SuiTypography>
                  </DialogContentText>
                </DialogContent>
                {!messageData.answer &&
                  (contact.type == 1 ? (
                    <DialogActions>
                      <SuiButton
                        variant="gradient"
                        color="light"
                        className="leading-5 p-2"
                        onClick={() => setRequestResponse("Withdraw", messageData)}
                      >
                        Withdraw
                      </SuiButton>
                    </DialogActions>
                  ) : (
                    <DialogActions>
                      <SuiButton
                        variant="gradient"
                        color="light"
                        className="leading-5 p-2"
                        onClick={() => setRequestResponse("Decline", messageData)}
                      >
                        Decline
                      </SuiButton>
                      <SuiButton
                        variant="gradient"
                        color="dark"
                        className="leading-5 p-2"
                        onClick={() => setRequestResponse("Accept", messageData)}
                      >
                        Accept
                      </SuiButton>
                    </DialogActions>
                  ))}
              </Card>
            )}
            {contact.type == 0 &&
              messageData.type == 4 &&
              messageData.tag == "Complete Project" &&
              messageData.answer == "Accept" && (
                <Card
                  className={`w-full mt-6 rounded-lg p-2 ${
                    contact.type == 1 ? bgcolor_owner_body_plus : bgcolor_friend_body_plus
                  }`}
                >
                  <DialogTitle id="alert-dialog-title">Your opinion matters!</DialogTitle>
                  <DialogContent>
                    <SuiTypography variant="body1" className="whitespace-pre-line">
                      {parse(
                        contact.type == 1
                          ? `Designer <b><i>${chatdata.name}</i></b> want you to share your experience for this project with other manufacturers. `
                          : `Manufacturer <b><i>${chatdata.name}</i></b> want you to share your experience for your project with other designers. `
                      )}
                      Please take a moment to review your recent project experience.
                    </SuiTypography>
                  </DialogContent>
                  <div>
                    <SuiTypography
                      className="flex justify-center"
                      variant="button"
                      textTransform="none"
                    >
                      Rate your experience with{" "}
                      {contact.type == 1
                        ? `Designer ${chatdata.name}`
                        : `Manufacturer ${chatdata.name}`}
                    </SuiTypography>
                    <SuiBox
                      sx={{ cursor: "pointer" }}
                      onClick={() => setReviewDialogVisiable(true)}
                    >
                      <Rating
                        className="flex justify-center"
                        readOnly
                        defaultValue={reviewdata.rating}
                        name="rating"
                      />
                    </SuiBox>
                  </div>
                  {reviewDialogVisiable && (
                    <Prompt
                      heading={contact.type == 1 ? "Review Designer" : "Review Manufacturer"}
                      option={{ maxWidth: "md", fullWidth: true }}
                      text={
                        <SuiBox display="flex" flexDirection="column" height="100%">
                          <Rating
                            size="large"
                            className="justify-center"
                            defaultValue={reviewRating}
                            name="selectrating"
                            onChange={(e, n) => setReviewRating(n)}
                          />
                          <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Share details of your own experience
                            </SuiTypography>
                          </SuiBox>
                          <SuiInput
                            sx={{ minWidth: "480px" }}
                            defaultValue={reviewdata.value}
                            minRows={3}
                            maxRows={10}
                            multiline
                            onChange={(e) => setReviewMessage(e.target.value)}
                          />
                        </SuiBox>
                      }
                      visible={reviewDialogVisiable}
                      okText="Post"
                      okColor="dark"
                      handleOk={async () => {
                        var msg = reviewMessage == "" ? " " : reviewMessage;
                        try {
                          if (reviewdata.id)
                            await api.notes.update(reviewdata.id, {
                              value: msg,
                              rating: reviewRating,
                              resource_id: chatdata.contactid,
                              resource_type: contact.type == 1 ? "de" : "ma",
                            });
                          else
                            await api.notes.create(
                              chatdata.contactid,
                              contact.type == 1 ? "de" : "ma",
                              msg,
                              reviewRating,
                              chatdata.regardingid
                            );
                          refreshReview();
                        } catch (err) {
                          toast.error(`listChatRoom failed!`);
                          console.log(err);
                        }
                        setReviewDialogVisiable(false);
                      }}
                      handleClose={() => setReviewDialogVisiable(false)}
                    />
                  )}
                </Card>
              )}
            {messageData.type == 0 && messageData.desc && (
              <SuiTypography mb={2} variant="body1" className="leading-5 whitespace-pre-line">
                {parse(messageData.desc)}
              </SuiTypography>
            )}
            {(messageData.type == 0 || messageData.type == 2) && (
              <SuiTypography variant="body1" className="leading-5 whitespace-pre-line">
                {messageData.text}
              </SuiTypography>
            )}
          </p>
          <div className={`leading-5 whitespace-nowrap`}>
            <div className={`flex items-center ${isInfo ? "justify-center" : "justify-end"}`}>
              {label && <div className="mr-1 flex items-center">{label.icon}</div>}
              {isStarred && <StarredIcon />}
              <SuiTypography variant="body2" className="opacity-60 ml-1.5 mr-1">
                {smartdate.format(new Date(messageData.ts))}
              </SuiTypography>
            </div>
          </div>
        </Card>
        {contact.type == 1 && <ContactAvatar contact={contact} size={avatorsize} />}
        {dialogVisible && (
          <Prompt
            heading={`${response.answer} ${response.tag} Request`}
            text={`Are you sure you want to ${response.answer.toLowerCase()} current request?`}
            visible={dialogVisible}
            okText="Yes"
            okColor="dark"
            cancelText="No"
            handleOk={async () => {
              setDialogVisible(false);
              if (response.answer == "Accept") {
                // console.log("messageData", messageData);
                var ok = await updateProjectStatus(messageData.pstatus);
                if (ok) sendmessage(response, true);
              } else sendmessage(response);
            }}
            handleClose={() => setDialogVisible(false)}
          />
        )}
      </div>
    );
  };

  return (
    <div>
      {id ? (
        <Card
          className={`overflow-hidden cardstyle h-full ${
            relstatus == 0 ? "" : "bg-gradient-lighter"
          } ${cardClassName}`}
        >
          <Toolbar
            className={`d-inline-block header ${bgcolor_header}`}
            disableGutters={backaction != null}
          >
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                {backaction && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      backaction();
                    }}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <ArrowBackIosNewIcon />
                  </IconButton>
                )}
                <ContactAvatar room={chatdata} size={avatorsize} />
                <div className="ml-1">
                  <SuiBox display="flex" alignItems="center">
                    <SuiTypography variant="button">{chatdata.name}</SuiTypography>
                    {isProjectRelated && (
                      <Link
                        to={
                          chatdata.regardingownerid == userid
                            ? `/produce/all-projects?id=${regardingid}`
                            : `/job/requests?id=${regardingid}`
                        }
                        target="_blank"
                        style={{ color: "inherit" }}
                      >
                        <SuiTypography variant="button" sx={{ ml: 1 }}>
                          (
                          <SuiTypography
                            sx={{ textDecoration: "underline" }}
                            display="inline"
                            variant="button"
                          >
                            {chatdata.regardingname}
                          </SuiTypography>
                          )
                        </SuiTypography>
                      </Link>
                    )}
                  </SuiBox>
                  <SuiTypography
                    className={`block text-xs ${
                      messageList.length < chatdata.totalmsgcnt ? "text-red-500 font-bold" : ""
                    }`}
                  >
                    Showing {messageList.length} out of {chatdata.totalmsgcnt} messages
                  </SuiTypography>
                </div>
              </div>
              <div className={`flex items-center`}>
                {false && parentReload && isProjectRelated && (
                  <Tooltip title={"View Project"} placement="top-start">
                    <IconButton
                      onClick={() => {
                        setChatRoomId((prevId) => ({ ...prevId, id: "" }));
                      }}
                      size="small"
                    >
                      <Link
                        to={
                          chatdata.regardingownerid == userid
                            ? `/produce/all-projects?id=${regardingid}`
                            : `/job/requests?id=${regardingid}`
                        }
                        target="_blank"
                        style={{ color: "inherit" }}
                      >
                        <SuiButton
                          sx={{ mb: 0, mt: 0, pb: 0, pt: 0, fontSize: 12 }}
                          size="small"
                          variant="gradient"
                          color="dark"
                          className="small:px-0 medium:px-2 "
                        >
                          View
                          <br />
                          Project
                        </SuiButton>
                      </Link>
                    </IconButton>
                  </Tooltip>
                )}
                {setChatRoomId && chatdata.regardingstatus == "requested" && (
                  <Tooltip title={"Inquiry"} placement="top-start">
                    <IconButton
                      onClick={() => {
                        setChatRoomId((prevId) => ({ ...prevId, id: "" }));
                      }}
                      size="small"
                    >
                      <SuiButton
                        sx={{ mb: 0, mt: 0, pb: 0, pt: 0, fontSize: 12 }}
                        size="small"
                        variant="gradient"
                        color="dark"
                        className="small:px-0 medium:px-2 "
                      >
                        Send
                        <br />
                        Inquiry
                      </SuiButton>
                    </IconButton>
                  </Tooltip>
                )}
                {inSearchMode && (
                  <SuiInput
                    autoFocus
                    size="small"
                    value={searchTxt}
                    onChange={(event) => setSearchTxt(event.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        setSearchStr(searchTxt);
                        event.preventDefault();
                      }
                    }}
                  />
                )}
                <Tooltip title={inSearchMode ? "Clear" : "Search"} placement="top-start">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearchTxt("");
                      setSearchStr("");
                      setInSearchMode(!inSearchMode);
                    }}
                  >
                    <Icon
                      fontSize="small"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    >
                      {inSearchMode ? "clear" : "search"}
                    </Icon>
                  </IconButton>
                </Tooltip>
                {isProjectRelated && (
                  <ChooseLabel
                    tag="filterlabel"
                    selectedLabelId={labelFilter}
                    setSelectedLabelId={setLabelFilter}
                  />
                )}
                <Tooltip
                  title={inStarMode ? "All Messages" : "Starred Messages"}
                  placement="top-start"
                >
                  <IconButton
                    size="small"
                    onClick={() => {
                      setInStarMode(!inStarMode);
                    }}
                  >
                    {inStarMode ? <StarredIcon /> : <UnStarredIcon />}
                  </IconButton>
                </Tooltip>
                {chatdata.regardingtype !== 1 && chatdata.contactid !== "UpStyled" && (
                  <RenderChatMenu
                    userid={userid}
                    chatdata={chatdata}
                    parentReload={parentReload}
                    setRelStatus={setRelStatus}
                    socketRef={socketRef}
                  />
                )}
              </div>
            </div>
          </Toolbar>
          <div
            className={`relative ${
              backaction != null ? "p-1" : "p-6"
            } overflow-y-auto h-[55vh] ${bgcolor_body}`}
          >
            {messageList.map((messagestr, index, array) => {
              let messageData = JSON.parse(messagestr);
              return (
                <div
                  ref={
                    focusMsg == messageData.id || (!focusMsg && index == array.length - 1)
                      ? focusRef
                      : null
                  }
                >
                  <MessageItem key={messageData.id} messageData={messageData} />
                </div>
              );
            })}
          </div>
          {originMsg && (
            <SuiBox
              className={`flex items-center w-full pt-3 pr-3 border-t border-gray-200 ${bgcolor_header}`}
            >
              <span className={`${isProjectRelated ? "w-[125px]" : "w-[88px]"} grow-0`} />
              <SuiTypography
                variant="body1"
                className={`grow rounded-lg h-14 p-2 line-clamp-2 text-[#667781] ${bgcolor_owner_body}`}
              >
                {(originMsg.user_id == userid ? "You" : getContact(originMsg.user_id).name) +
                  ": " +
                  originMsg.text.replaceAll("\n", ".").replaceAll(/\.\.+/g, ".")}
              </SuiTypography>
              <IconButton onClick={() => setOriginMsg(null)}>
                <Icon fontSize="small">cancel</Icon>
              </IconButton>
            </SuiBox>
          )}
          {relstatus == 0 ? (
            <div
              className={`flex items-center justify-between w-full p-3 border-t border-gray-300 ${bgcolor_header}`}
            >
              <Upload
                multiple
                name="avatar"
                className="align-middle"
                showUploadList={false}
                customRequest={handleUpload}
              >
                <Tooltip title="Send Files" placement="top-start">
                  <IconButton>
                    <Icon fontSize="small">attach_file</Icon>
                  </IconButton>
                </Tooltip>
              </Upload>
              {isProjectRelated ? (
                <ChooseLabel
                  tag="newmessagelabel"
                  selectedLabelId={newMsgLabel}
                  setSelectedLabelId={setNewMsgLabel}
                />
              ) : null}
              <Tooltip title={newMsgStar ? "Unstar Message" : "Star Message"} placement="top-start">
                <IconButton
                  size="small"
                  onClick={() => {
                    setNewMsgStar(!newMsgStar);
                  }}
                >
                  {newMsgStar ? <StarredIcon /> : <UnStarredIcon />}
                </IconButton>
              </Tooltip>
              <SuiInput
                multiline
                maxRows={5}
                value={message}
                onChange={(event) => setMessage(event.target.value)}
                onKeyPress={(event) => {
                  if (event.key === "Enter" && !event.shiftKey) {
                    sendMessageData();
                    event.preventDefault();
                  }
                }}
              />
              <IconButton onClick={() => sendMessageData()}>
                <Icon fontSize="small">send</Icon>
              </IconButton>
            </div>
          ) : null}
        </Card>
      ) : null}
    </div>
  );
};

export default ChatRoom;
